module.exports = __webpack_public_path__ + "static/img/IT-Teams.89fe92eb.jpg";